"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestQuote = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var component_library_waas_templates_base_input_1 = require("@tradesorg/component-library-waas-templates.base-input");

var component_library_waas_templates_base_button_1 = require("@tradesorg/component-library-waas-templates.base-button");

var close_svg_1 = __importDefault(require("./close.svg"));

require("./template-1-request-quote.css");

require("react-datepicker/dist/react-datepicker.css");

function RequestQuote(_ref) {
  var title = _ref.title,
      percent = _ref.percent,
      isModal = _ref.isModal,
      open = _ref.open,
      setOpen = _ref.setOpen,
      showCalendar = _ref.showCalendar,
      isCalendar = _ref.isCalendar,
      setShowCalendar = _ref.setShowCalendar,
      setStartDate = _ref.setStartDate,
      startDate = _ref.startDate,
      time = _ref.time,
      setTime = _ref.setTime,
      step = _ref.step,
      setStep = _ref.setStep,
      indexTime = _ref.indexTime,
      setIndexTime = _ref.setIndexTime,
      showModalMobile = _ref.showModalMobile,
      setShowModalMobile = _ref.setShowModalMobile,
      urlHubspot = _ref.urlHubspot,
      modalClassName = _ref.modalClassName,
      values = _ref.values,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      errorMessage = _ref.errorMessage,
      isLoading = _ref.isLoading;
  console.log(errorMessage);
  return react_1.default.createElement(ContainerNormal, {
    title: title,
    percent: percent,
    isModal: isModal,
    open: open,
    setOpen: setOpen,
    showCalendar: showCalendar,
    isCalendar: isCalendar,
    setShowCalendar: setShowCalendar,
    setStartDate: setStartDate,
    startDate: startDate,
    time: time,
    setTime: setTime,
    step: step,
    setStep: setStep,
    indexTime: indexTime,
    setIndexTime: setIndexTime,
    showModalMobile: showModalMobile,
    setShowModalMobile: setShowModalMobile,
    urlHubspot: urlHubspot,
    values: values,
    onSubmit: onSubmit,
    onChange: onChange,
    errorMessage: errorMessage,
    isLoading: isLoading
  });
}

exports.RequestQuote = RequestQuote;
RequestQuote.propTypes = {
  title: prop_types_1.default.string,
  percent: prop_types_1.default.string,
  isModal: prop_types_1.default.bool,
  open: prop_types_1.default.bool,
  setOpen: prop_types_1.default.func,
  showCalendar: prop_types_1.default.bool,
  isCalendar: prop_types_1.default.bool,
  setShowCalendar: prop_types_1.default.func,
  setStartDate: prop_types_1.default.func,
  startDate: prop_types_1.default.string,
  time: prop_types_1.default.string,
  setTime: prop_types_1.default.func,
  step: prop_types_1.default.string,
  setStep: prop_types_1.default.func,
  indexTime: prop_types_1.default.number,
  setIndexTime: prop_types_1.default.func,
  showModalMobile: prop_types_1.default.bool,
  setShowModalMobile: prop_types_1.default.func,
  urlHubspot: prop_types_1.default.string,
  modalClassName: prop_types_1.default.string,
  values: prop_types_1.default.object,
  onSubmit: prop_types_1.default.func,
  onChange: prop_types_1.default.func
};
RequestQuote.defaultProps = {
  title: 'Request a quote',
  percent: '15%',
  isModal: false,
  setOpen: function setOpen() {},
  showCalendar: false,
  modalClassName: '',
  onSubmit: function onSubmit(event) {
    event.preventDefault();
  }
};

var ContainerNormal = function ContainerNormal(_ref2) {
  var title = _ref2.title,
      percent = _ref2.percent,
      isModal = _ref2.isModal,
      setOpen = _ref2.setOpen,
      showCalendar = _ref2.showCalendar,
      isCalendar = _ref2.isCalendar,
      setShowCalendar = _ref2.setShowCalendar,
      startDate = _ref2.startDate,
      showModalMobile = _ref2.showModalMobile,
      setShowModalMobile = _ref2.setShowModalMobile,
      urlHubspot = _ref2.urlHubspot,
      values = _ref2.values,
      onSubmit = _ref2.onSubmit,
      onChange = _ref2.onChange,
      errorMessage = _ref2.errorMessage,
      isLoading = _ref2.isLoading;
  console.log(errorMessage);
  return react_1.default.createElement("div", {
    className: "relative items-center justify-center h-auto px-8 py-16 bg-white md:pt-10 md:pb-10 xs:pb-8 container-req-quote grid grid-cols-1"
  }, isModal && react_1.default.createElement("div", {
    onClick: function onClick() {
      if (setOpen) setOpen(false);
    },
    className: "absolute items-center justify-center w-12 h-12 cursor-pointer top-5 right-5 custom-close grid"
  }, react_1.default.createElement("img", {
    src: close_svg_1.default,
    alt: ""
  })), react_1.default.createElement("div", {
    className: "text-2xl not-italic font-medium tracking-normal text-center leading-7"
  }, title), react_1.default.createElement("div", {
    className: "mt-2 text-base not-italic font-normal tracking-normal text-center leading-6"
  }, "Request a quote now and get a", ' ', react_1.default.createElement("b", {
    className: "text-base not-italic font-bold tracking-normal text-center leading-6"
  }, "$", percent, " discount*")), react_1.default.createElement("div", {
    style: {
      background: '#81B0C0'
    },
    className: "h-px rounded-none my-7"
  }), react_1.default.createElement("form", {
    noValidate: true,
    className: "items-center grid grid-cols-1 gap-2",
    onSubmit: onSubmit
  }, react_1.default.createElement("div", {
    className: "w-full"
  }, react_1.default.createElement("label", {
    htmlFor: "cta_name",
    className: "sr-only"
  }, "Name"), react_1.default.createElement(component_library_waas_templates_base_input_1.Input, {
    style: {
      border: '1px solid #e0e0e0'
    },
    id: "cta_name",
    type: "text",
    className: "w-full h-16 rounded-none custom-input",
    placeholder: "Your name",
    value: values === null || values === void 0 ? void 0 : values.cta_name,
    onChange: onChange
  })), react_1.default.createElement("div", {
    className: "w-full"
  }, react_1.default.createElement("label", {
    htmlFor: "cta_phone",
    className: "sr-only"
  }, "Phone Number"), react_1.default.createElement(component_library_waas_templates_base_input_1.Input, {
    style: {
      border: '1px solid #e0e0e0'
    },
    id: "cta_phone",
    type: "text",
    className: "w-full h-16 rounded-none custom-input",
    placeholder: "Your phone number",
    value: values === null || values === void 0 ? void 0 : values.cta_phone,
    onChange: onChange,
    "aria-describedby": "ctaPhone"
  })), react_1.default.createElement("div", {
    className: "w-full"
  }, react_1.default.createElement("label", {
    htmlFor: "cta_email",
    className: "sr-only"
  }, "Email Address"), react_1.default.createElement(component_library_waas_templates_base_input_1.Input, {
    style: {
      border: '1px solid #e0e0e0'
    },
    id: "cta_email",
    type: "text",
    className: "w-full h-16 rounded-none custom-input",
    placeholder: "Your email address",
    value: values === null || values === void 0 ? void 0 : values.cta_email,
    onChange: onChange,
    "aria-describedby": "ctaEmail"
  })), errorMessage && react_1.default.createElement("div", {
    className: "my-8 text-red-700"
  }, errorMessage), react_1.default.createElement("div", {
    className: "items-center w-full text-center custom-button"
  }, react_1.default.createElement(component_library_waas_templates_base_button_1.Button, {
    type: "submit",
    className: "h-16"
  }, isLoading ? react_1.default.createElement("p", {
    className: "text-sm not-italic font-bold tracking-normal text-center text-white leading-5"
  }, "Sending...") : react_1.default.createElement("p", {
    className: "text-sm not-italic font-bold tracking-normal text-center text-white leading-5"
  }, "REQUEST QUOTE NOW!")))));
};